<template>
  <div id="about__fundII" class="pb-4 fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">Ensino Fundamental II</h2>
          </b-container>
        </div>
      </div>
    </div>
    <BreadSistema class="bread__about" />

    <b-container fluid="lg" class="pt-4 pb-4">
      <div class="box-text">
        <div class="content-text">
          <h5 class="text-uppercase font-weight-bolder">Proposta Pedagógica</h5>
          <p class="lead font-weight-light">A ideia central desta Coleção é que, sempre que possível, um mesmo tema seja
            visto sob várias abordagens disciplinares.</p>
          <p class="mt-3">Além de os assuntos estarem contextualizados junto ao cotidiano
            do estudante, eles permeiam várias matérias, garantindo a interdisciplinaridade.</p>
          <p class="mt-3">Assim, o aprendizado acontece de forma significativa, colaborando para
            a construção de uma sólida formação cultural. A compreensão é favorecida por meio
            de leituras direcionadas e experimentos.</p>

          <h5 class="font-weight-bolder mt-4">Material didático</h5>
          <p>Adotando uma proposta visual que evolui com o crescimento das crianças, o material incentiva a
            criatividade,
            a curiosidade, o raciocínio, a interatividade, o gosto pela pesquisa e a aquisição de conhecimentos
            e valores. A partir da apropriação de temas pertencentes ao cotidiano, introduz
            os elementos que vão ampliar o repertório cultural. Cada novo tema é enriquecido com atividades práticas,
            jogos, músicas, debates, pesquisas, leituras e atividades que incentivam a interação com os colegas e a
            construção de atitudes que melhoram
            o convívio social.
          </p>
          <hr>
          <div class="d-block mx-auto">
            <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
            <p class="text text-center">
              Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
            </p>
            <div class="d-flex justify-content-center">
              <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                <i class="fa-regular fa-messages"></i>
                <span>Fale com um consultor</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ensino-infantil',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
};
</script>

<style lang="scss" scoped>
#about__fundII {
  background-color: #ffffff;

  #header {
    .img__header {
      background-image: url('https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2019/10/11164105/fund_i_comprimido.jpg');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 20px;
    line-height: 26px;
    padding: 0;
    margin: 0;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .content-text {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media screen and (min-width: 320px) and (max-width: 1200px) {
  .content-text {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
